import React, { useState, useEffect } from "react";
import CompanyCom from "./CompanyCom";
import birac from "./Img/support/birac.webp";
import ghrtbif from "./Img/support/ghtbif.webp";
import sineiit from "./Img/support/sineiit.webp";
import startup from "./Img/support/startup.webp";
import scitech from "./Img/support/scitech.webp";
//import sarthi from "./Img/support/sarthi.webp";
import advidarbha1 from "./Img/events/advidarbha1.webp";
import advidarbha from "./Img/events/advidarbha.webp";
import event1 from "./Img/events/event1.webp";
import unicorn from "./Img/events/unicorn.webp";
import Address from "./Address";

const supportedByData = [
  {
    items: [
      { image: birac, name: "BIRAC", role: "Ignite Innovate Incubate"},
      { image: sineiit, name: "SINE", role: "IIT Bombay"},
      { image: ghrtbif, name: "GHRTBIF", role: "G H Raisoni Technology Business Incubator Foundation"},
      //{ image: sarthi, name: "SARTHI", role: "Chhatrapati Shahu Maharaj Research,Training and Human Development Institute" },
      { image: scitech, name: "Science and Technology Park", role: "" },
      { image: startup, name: "StartupIndia", role: "" },
    ],
  },
];

const eventsData = [
  {
    items: [
      { image: advidarbha1, name: "Advantage Vidarbha", role: "Nitin Gadkari" },
      { image: advidarbha, name: "Advantage Vidarbha", role: "Devendra Fadnavis" },
      { image: event1, name: "HTG, Pune", role: " Dr.Raghunath Anant Mashelkar" },
      { image: unicorn, name: "Founders of ", role: "PristynCare,Apna, NoBroker,Policy Bazaar,NammaYatri " },
    ],
  },
];

function Company() {
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setPaused(true);
      setTimeout(() => {
        setPaused(false);
      }, 10000);
    }, 10000);
    return () => clearInterval(intervalId);
  }, [paused]);

  return (
    <>
      <div>
        <CompanyCom title="SUPPORTED BY" data={supportedByData}/>
        <CompanyCom title="EVENTS" data={eventsData} />
      </div>
      <Address />
    </>
  );
}

export default Company;